import Vue from 'vue'
import Vuex, { Module } from 'vuex'
import actions from './actions'
import mutations from './mutations'
import state from './state'
import modules from './modules'
import { isString } from '@/utils'

Vue.use(Vuex)

const appStore = new Vuex.Store({
  actions,
  mutations,
  state,
  modules
})

export default appStore
/**
 * 动态注册store.module
 * @param {Route | string} to
 * @param {Module} store
 * @param {Boolean} useCache
 */
export function registerModule(to, store, useCache = false) {
  // console.log(to,store);
  let name = ''
  let keepAlive = useCache
  if (isString(to)) {
    name = to
  } else if (to?.name) {
    name = to.name
    keepAlive = to?.meta?.keepAlive
  }

  if (name) {
    if (appStore.hasModule(name)) {
      if (!keepAlive) {
        appStore.unregisterModule(name)
        appStore.registerModule(name, store)
      }
    } else {
      appStore.registerModule(name, store)
    }
  }
}
